import { format, isValid } from 'date-fns';

import { queryKeys, queryValues } from '~/routes/query-params';

const safeFormatDate = (value: string, pattern: string): string => {
  const date = new Date(value);
  return value && isValid(date) ? format(date, pattern) : '';
};

export const formatDateRange = (from: string, to: string) => ({
  formattedFrom: safeFormatDate(from, 'MM/dd/yyyy'),
  formattedTo: safeFormatDate(to, 'MM/dd/yyyy'),
});

export const getEconomicCalendarDrawerParams = (
  params: Record<string, string | null>
) => {
  const rawCountries = params[queryKeys.economicCalendarCountries];
  const rawCategories = params[queryKeys.economicCalendarCategories];
  return {
    isOpen: params[queryKeys.activeDrawer] === queryValues.economicCalendarDrawer,
    from: params[queryKeys.economicCalendarFrom] ?? '',
    to: params[queryKeys.economicCalendarTo] ?? '',
    countries: rawCountries
      ? rawCountries.split(',').map(c => c.trim()).filter(Boolean)
      : [],
    categories: rawCategories
      ? rawCategories.split(',').map(c => c.trim()).filter(Boolean)
      : [],
    entityTag: params[queryKeys.economicCalendarEntityTag] ?? '',
  };
};
